import { AppDispatch } from '@/app/store';
import { Location, Outlet } from 'react-router-dom';
import { ROUTE_MAIN_CREATE_LETTER_PAYMENT } from '@/app/routes';
import { clearFormState, clearLetterDraftId, getLetterSent } from '@/services/createFormSlice';
import { clearLetterSbpState } from '@/services/sbpSlice';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { useLocation } from 'react-router-dom';
import React, { FC, ReactElement, useEffect } from 'react';

export const MainLetterBlock: FC = (): ReactElement => {
  const dispatch: AppDispatch = useAppDispatch();
  const location: Location = useLocation();

  const isLetterSent: boolean = useAppSelector(getLetterSent);

  useEffect((): void => {
    if (isLetterSent && !location.pathname.includes(ROUTE_MAIN_CREATE_LETTER_PAYMENT)) {
      dispatch(clearFormState());
      dispatch(clearLetterSbpState());
    }
  }, [dispatch, location, isLetterSent]);

  useEffect(() => {
    return (): void => {
      dispatch(clearLetterDraftId());
    };
  }, [dispatch]);

  return <Outlet />;
};
